import dayjs from "dayjs";
import { FC } from "react";
import { ICreditBalanceBreakdown } from "../../interfaces/wallet/Wallet.types";
import { eur } from "../../utils/eur";

interface Props {
  breakdown: ICreditBalanceBreakdown;
}

// Separate cards, not a split bar: flexible credits count toward both products, so the figures overlap.
const BalanceFigures: FC<Props> = ({ breakdown }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <div className="border border-gray-200 rounded-lg p-4">
      <p className="text-xs text-gray-500">Gjithsej</p>
      <p className="text-2xl font-medium">{eur(breakdown.total)}</p>
    </div>

    <div className="border border-gray-200 rounded-lg p-4">
      <p className="text-xs text-gray-500">Për bileta</p>
      <p className="text-2xl font-medium">{eur(breakdown.spendableOnTravel)}</p>
      <p className="text-xs text-gray-500 mt-1">
        {eur(breakdown.flexibleAny)} për të dyja + {eur(breakdown.travelOnly)}{" "}
        vetëm bileta
      </p>
    </div>

    <div className="border border-gray-200 rounded-lg p-4">
      <p className="text-xs text-gray-500">Për eSIM</p>
      <p className="text-2xl font-medium">{eur(breakdown.spendableOnEsim)}</p>
      <p className="text-xs text-gray-500 mt-1">
        {eur(breakdown.flexibleAny)} për të dyja + {eur(breakdown.esimOnly)}{" "}
        vetëm eSIM
      </p>
    </div>

    {breakdown.nextExpiryAtUtc && (
      <div className="md:col-span-3 text-xs text-gray-600 border-l-2 border-orange pl-3">
        {eur(breakdown.nextExpiryAmount)} duhen përdorur deri më{" "}
        {dayjs(breakdown.nextExpiryAtUtc).format("DD/MM/YYYY")}.
      </div>
    )}
  </div>
);

export default BalanceFigures;
